import { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface Position {
    id: string;
    name: string;
}

export const usePositions = () => {
    const [positions, setPositions] = useState<Position[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchPositions = async () => {
            try {
                const positionsCollection = collection(db, 'positions');
                const q = query(positionsCollection, orderBy('name'));
                const querySnapshot = await getDocs(q);
                const positionsList = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                })) as Position[];
                setPositions(positionsList);
            } catch (err) {
                console.error("Error fetching positions:", err);
                setError('Falha ao buscar cargos.');
            } finally {
                setLoading(false);
            }
        };

        fetchPositions();
    }, []);

    return { positions, loading, error };
}; 